<template>
	<v-dialog
			:value="isViewHolidays"
			content-class="dialogWrapper"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
	>
		<div class="dialogWrap">
			<div class="dialogTitle">
				<span>View holidays</span>
				<button type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="dialogMain">
				<div class="fieldWrapper">
					<field
							:class-error="getError('name')"
							margin="0"
							width="100%"
							label="Name"
							placeholder="Enter name"
							:setInputValue="name"
							@updateInput="onInput($event, 'name')"
							is-required
					></field>
					<field
							:class-error="getError('date')"
							margin="0"
							width="100%"
							type="text"
							label="Date"
							placeholder="YYYY-MM-DD"
							:dateValue="date"
							display-format="YYYY-MM-DD"
							@updateTime="onTime($event, 'date')"
							is-time
							is-required
							:pickTime="false"
					></field>
				</div>
				<div class="main">
					<div class="departmenTableWrapper">
						<department-table
								v-for="(items, index) in departments"
								:key="index"
								:index="index"
								:items="items"
						></department-table>
					</div>
				</div>
				<div class="footer">
					<custom-btn
							text="Save"
							@updateEvent="onSave"
							custom-class="apply"
							is-all-elements
							margin='0'
							:icon-attrs="{width: 20, height: 20, iconId: 'safe'}"
					></custom-btn>
					<custom-btn
							text="Close"
							@updateEvent="onClose"
							is-all-elements
							margin='0'
							:icon-attrs="{width: 20, height: 20, iconId: 'close'}"
					></custom-btn>
				</div>
			</div>
		</div>
		<preload v-if="isPreloader"></preload>

	</v-dialog>
</template>

<script>

import Vue from 'vue';

// Prefered: as a plugin (directive + filter) + custom placeholders support
import VueMask from 'v-mask';
Vue.use(VueMask);

// validation
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import { mapActions, mapGetters } from "vuex";
import Preload from "@/shared/Preload/Preload.vue";
import DepartmentTable
from "@/components/Settings/UserAccountSettings/ViewHolidays/DepartmentTable/DepartmentTable.vue";
export default {
	name: "ViewHolidays",
	components: { DepartmentTable, Preload },
	computed: {
		...mapGetters([
			'createHolidays',
			'editHolidays',
		]),

	},
	mixins: [ validationMixin ],
	props: {
		dialogFlag: String,
	},
	validations: {
		name: { required },
		date: { required },
	},
	data: () => ({
		isViewHolidays: true,
		id: null,
		name: null,
		date: null,
		departments: null,
		isPreloader: false,

	}),

	methods: {
		...mapActions([ 'setAlert', 'onAccountHolidaysSave', 'onAccountHolidaysEdit', 'getAccountHolidaysCreate' ]),

		onInput({ value }, key) {
			this[key] = value;
		},
		onTime(value, key) {
			this[key] = value;
			// this.$emit('updateTime', { value, key });
		},

		async onSave() {
			this.isPreloader = true;

			this.departments.forEach(department => {
				department.employees.forEach(employee => {
					employee.status = employee.isCheck ? 1 : 0;
				});
			});

			this.$v.$touch();
			if (!this.$v.$error) {
				const { id, name, date, departments } = this.$data;
				const holidays = { name, date };
				const values = departments;
				const sendInfo = { holidays, values };

				if (this.dialogFlag === 'add') {
					await this.onAccountHolidaysSave({ sendInfo, id });
				} else {
					await this.onAccountHolidaysEdit({ sendInfo, id });
				}

				this.$emit('updateClose');
				this.$emit('updateList');
			} else {
				await this.setAlert({ type: "error", message: "Saving error" });
			}
			this.isPreloader = false;

		},

		onClose() {
			this.$emit('updateClose');
		},

		getError(key) {
			return this.$v && this.$v[key] && this.$v[key].$error;
		},
	},
	async mounted() {
		this.isPreloader = true;

		await this.getAccountHolidaysCreate();

		if (this.dialogFlag === 'add') {
			this.id = null;
			this.name = null;
			this.date = null;
			this.departments = this.createHolidays;

		} else {
			this.departments = this.editHolidays.values;
			this.id = this.editHolidays.holidays.id;
			this.name = this.editHolidays.holidays.name;
			this.date = `${ this.editHolidays.holidays.date } 00:00`;

			this.departments.forEach(department => {
				department.employees.forEach(employee => {
					employee.isCheck = employee.status ? 1 : 0;
				});
			});
		}

		this.isPreloader = false;
	},
};
</script>

<style scoped lang="scss">
@import "../ViewVersion/ViewVersion";

.dialogWrapper {
	.dialogMain {
		height: calc(100% - 70px);
		.main {
			height: calc(100% - 100px);
			overflow: auto;
			.departmenTableWrapper {
				display: block;
				padding-top: 10px;
				margin-bottom: 10px;
				column-count: 4;
				column-gap: 10px;
				@media screen and (max-width: 1200px) {
					column-count: 3;
				}
				@media screen and (max-width: 768px) {
					column-count: 2;
				}
				@media screen and (max-width: 390px) {
					column-count: 1;
				}
			}
		}
	}
}

</style>
